import { X, Download } from 'lucide-react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { useState, useEffect } from 'react';

export function PWAInstallButton() {
  const { isInstallable, promptInstall, dismissPrompt } = usePWAInstall();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isInstallable) {
      // Delay showing the button for better UX (not too intrusive)
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isInstallable]);

  const handleInstall = async () => {
    await promptInstall();
  };

  const handleDismiss = () => {
    dismissPrompt();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-4 right-4 z-50 animate-fade-in"
      style={{
        animation: 'fadeIn 0.3s ease-in-out'
      }}
    >
      <div className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl shadow-lg p-4 flex items-center gap-3 max-w-sm">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
            <Download className="w-5 h-5" />
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold">Install Fittory</p>
          <p className="text-xs text-white/90">Get quick access from your home screen</p>
        </div>

        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={handleInstall}
            className="px-4 py-2 bg-white text-emerald-600 rounded-lg text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Install
          </button>
          <button
            onClick={handleDismiss}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
